/**
 *  积分规则
 * */
import React, { PureComponent } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { Button } from 'antd';
import model from '@/reducers/market/accumulaterule/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Accumulate extends PureComponent {

    state = {
        memberSwitch: '',//邀请会员开启--1 赠送；0-不赠送
        memberSwitchCode: '',//邀请会员开启code
        integralm: '',//邀请会员积分
        ceilingm: '',//邀请会员上限/次数 --0表示不限，否则自定义且表示次数
        knightSwitch: '',//邀请骑士开启--1 赠送；0-不赠送
        knightSwitchCode: '',//邀请骑士开启code
        integralk: '',//邀请骑士积分
        ceilingk: '',//邀请骑士上限/次数 --0表示不限，否则自定义且表示次数
    }

    componentDidMount() {
        const { setBreadcrumbPaths, match, getAccumulateList } = this.props;
        getAccumulateList({ paramType: 'INTEGRAL_RULE' });
        setBreadcrumbPaths(match); // 自动识别面包屑
    }

    componentDidUpdate(prevProps) {
        if (this.props.accumulateList !== prevProps.accumulateList) {
            this.ruleListHandle(this.props.accumulateList);
        }
    }

    //设置积分产生策略
    accumulate = () => {
        const { history, } = this.props;
        history.push({
            pathname: '/home/market/accumulaterule/setting'
        });
    }

    //数据处理
    ruleListHandle = (data) => {
        let arr = data.map((v) => {
            switch (v.paramCode) {
                case 'IS_GIVE_INTEGRAL_INVITE_USER'://邀请会员开启
                    this.setState({
                        memberSwitch: v.paramValue == '1' ? '已启用' : v.paramValue == '0' ? '未启用' : '',
                        memberSwitchCode: v.paramValue,
                    });
                    return;
                case 'INTEGRAL_NUMBER_INVITE_USER'://邀请会员积分
                    this.setState({ integralm: v.paramValue });
                    return;
                case 'INTEGRAL_UPPER_LIMIT_INVITE_USER'://邀请会员上限/次数
                    this.setState({ ceilingm: v.paramValue == '0' ? '不限' : `${v.paramValue} 次` });
                    return;
                case 'IS_GIVE_INTEGRAL_INVITE_RIDER'://邀请骑士开启
                    this.setState({
                        knightSwitch: v.paramValue == '1' ? '已启用' : v.paramValue == '0' ? '未启用' : '',
                        knightSwitchCode: v.paramValue,
                    });
                    return;
                case 'INTEGRAL_NUMBER_INVITE_RIDER'://邀请骑士积分
                    this.setState({ integralk: v.paramValue });
                    return;
                case 'INTEGRAL_UPPER_LIMIT_INVITE_RIDER'://邀请骑士上限/次数
                    this.setState({ ceilingk: v.paramValue == '0' ? '不限' : `${v.paramValue} 次` });
                    return;
            };

        });
    }

    render() {
        const { memberSwitch, integralm, ceilingm, knightSwitch, integralk, ceilingk, memberSwitchCode, knightSwitchCode } = this.state;
        return (
            <div className={styles.tablehead} >
                <div className={styles.homeLayout}>
                    <div className={styles.title}>
                        <div className={styles.left}>
                            <h5>邀请送积分</h5>
                            <span>积分目前可用于兑换优惠券</span>
                        </div>
                        <div className={styles.right}> <Button onClick={this.accumulate} type="primary">设置积分产生策略</Button></div>
                    </div>
                    <div className={styles.content}>
                        <div className={styles.list}>
                            <div className={styles.cont}>
                                <label>邀请会员</label>
                                <span className={styles.ruleColor}>{memberSwitch}</span>
                            </div>
                            {memberSwitchCode == '1' ? <p>会员每邀请一名会员注册成功送 <span className={styles.ruleColor}>{integralm}</span>  积分，
                            每日赠送上限  <span className={styles.ruleColor}>{ceilingm}</span></p> : <p>邀请会员送积分规则未启用</p>}
                        </div>
                        <div className={styles.list}>
                            <div className={styles.cont}>
                                <label>邀请骑士</label>
                                <span className={styles.ruleColor}>{knightSwitch}</span>
                            </div>
                            {knightSwitchCode == '1' ? <p>会员每邀请一名骑士注册成功送  <span className={styles.ruleColor}>{integralk}</span>  积分，
                            每日赠送上限  <span className={styles.ruleColor}>{ceilingk}</span></p> : <p>邀请骑士送积分规则未启用</p>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Accumulate.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    accumulateList: PropTypes.array,
    getAccumulateList: PropTypes.func,//积分规则查询(action)
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

const mapStateToProps = (state) => {
    return {
        accumulateList: state.accumulaterule.accumulateList,
    };
};

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Accumulate);
